import axios from "../api";
/**
 * The ids behind a withheld chain set. Metered: the backend charges the
 * credit, and the host must have asked the user first (see useCreditGate).
 */
export const revealChains = async ({ resourceId, chainSetId, }) => {
    const res = await axios.post(`/players/${resourceId}/next-evo-steps/reveal-chains/${chainSetId}`);
    return res.data;
};
//# sourceMappingURL=revealChains.js.map